import { createContentPropTypes } from '../../../helpers/content';

const payeeContent = {
	name: 'Name',
	displayName: 'Nickname',
	sortCode: 'Sortcode',
	accountNumber: 'Account number',
	reference: 'Reference',
	header: 'Manage your payees',
	viewPayeeHeader: 'View payee',
	editPayeeButton: 'Edit',
	deletePayeeButton: 'Delete',
	backButton: 'Back',
	deletePayeeSuccessMessage: 'has now been deleted from your list of payees.',
	payeeAddress: 'Payee address',
	bankAddress: 'Bank address',
	bic: 'BIC',
	iban: 'IBAN',
	chapsReference: 'CHAPS reference',
	otherPaymentReference: 'Other payment reference',
	reasonForPayment: 'Reason for payment',
	clearingCode: 'Clearing code',
};

export const contentPropTypes = createContentPropTypes(payeeContent);

export default payeeContent;
